import { Close, Cloud, CloudDownload, CloudUpload, ImageNotSupported } from '@mui/icons-material';
import { Button, Typography } from '@mui/material'
import React, { Component } from 'react'
import MediaManagerDialog from '../../areas/mediamanager/MediaManagerDialog';
import { APIData } from '../../constants/APIAdresses';

export const resizeImage = (file, targetWidth, targetHeight, onSelect) => {
    const targetAspectRatio = targetWidth / targetHeight;

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const imgAspectRatio = img.width / img.height;
                let cropWidth, cropHeight;

                // Determine the crop dimensions to maintain the aspect ratio
                if (imgAspectRatio > targetAspectRatio) {
                    // Image is wider than the target aspect ratio
                    cropHeight = img.height;
                    cropWidth = cropHeight * targetAspectRatio;
                } else {
                    // Image is taller than the target aspect ratio
                    cropWidth = img.width;
                    cropHeight = cropWidth / targetAspectRatio;
                }

                // Calculate the position to start the crop from the center
                const cropX = (img.width - cropWidth) / 2;
                const cropY = (img.height - cropHeight) / 2;

                // Create a canvas and resize the image
                const canvas = document.createElement('canvas');
                canvas.width = targetWidth;
                canvas.height = targetHeight;
                const ctx = canvas.getContext('2d');

                // Draw the cropped image, then resize it to target dimensions
                ctx.drawImage(
                    img,
                    cropX, cropY,             // Start cropping from (cropX, cropY)
                    cropWidth, cropHeight,     // Crop size (width and height)
                    0, 0,                     // Start drawing on the canvas at (0, 0)
                    targetWidth, targetHeight  // Resize to target width and height
                );

                // Convert the canvas back to a Blob and resolve the Promise with the new file
                canvas.toBlob((blob) => {
                    // console.log("Blobfile: ", file.name);
                    // console.log("Blobtype: ", file.type);
                    // console.log("Blob: ", new File([blob], file.name, { type: file.type }));
                    onSelect != null && onSelect(new File([blob], file.name, { type: file.type }));
                    resolve(new File([blob], file.name, { type: file.type }));
                }, file.type);
            };
            img.src = event.target.result;
        };
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
    });
};
export const IMAGE_FILE_DIMENSIONS = {
    products: { width: 500, height: 500 },
    categories: { width: 800, height: 200 },
    backgrounds: { width: 800, height: 800 },
    headers: { width: 800, height: 200 },
    icons: { width: 500, height: 500 },
}
export class CloudImageField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imgLoadErr: false,
            localSelection: null,
            borderColor: '#C4C4C4',
            mediaDialogOpen: false,
            newSelection: false,
        }
        this.errColor = '#d3302f';
        // #d3302f
        console.log("PROPS: ", this.props);
    }
    handleFileChange(e) {
        const file = e.target.files[0];
        // const resizedFile = await resizeImage(file, 500, 500);
        const width = this.props.dimensions?.width != null ? this.props.dimensions.width : 500;
        const height = this.props.dimensions?.height != null ? this.props.dimensions.height : 500;

        // const width = this.props.dimensions.width;
        this.resizeImage(file, width, height, this.props.onSelect).then((resizedFile) => {
            this.setState({ localSelection: resizedFile });
        });
        // setFile(resizedFile);
    }
    // shouldComponentUpdate(nextProps, nextState) {
    //     if (this.props.relPath !== nextProps.relPath || this.state.localSelection !== nextState.localSelection) {
    //         this.setState({ imgLoadErr: false });
    //     }
    //     return this.props.relPath !== nextProps.relPath || this.state.localSelection !== nextState.localSelection || this.state.imgLoadErr !== nextState.imgLoadErr || this.props.helperText !== nextProps.helperText;
    // }

    render() {
        return (
            <>

                <div onMouseEnter={() => { this.setState({ borderColor: '#353535' }) }} onMouseLeave={() => { this.setState({ borderColor: '#c4c4c4' }) }} style={{ display: "flex", flexDirection: "column", gap: 5, minWidth: 250, }}>
                    <div onClick={() => {
                        this.setState({ mediaDialogOpen: true })
                    }} style={{ display: "flex", flexDirection: "row", border: '1px solid ' + (this.props.helperText?.length > 0 ? this.errColor : this.state.borderColor), borderRadius: 4, height: 55 }}>
                        {this.state.newSelection &&
                            <div style={{ cursor: "pointer" }} onClick={(e) => {
                                e.stopPropagation();  // Klick nicht weiterleiten
                                this.setState({ newSelection: false });
                                this.props.onSelect?.(null);
                            }}>
                                <Close style={{ color: this.state.borderColor, width: 20, height: 20, marginLeft: 10, marginTop: 17 }} />
                            </div>
                        }
                        <div style={{ width: 60, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            {this.state.imgLoadErr || this.props.relPath?.length == 0 ?
                                <ImageNotSupported style={{ width: 40, height: 40 }} /> :
                                <img onError={() => { this.setState({ imgLoadErr: true }) }} src={`${APIData.MEDIA}${this.props.relPath}`} alt={"Bild!"} style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 20 }} />
                            }
                        </div>
                        <div style={{ flex: 5, display: "flex", alignItems: "center" }}>
                            <Typography style={{ color: "#353535" }}>{this.props.label}</Typography>
                        </div>
                        <div style={{ width: 50, height: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: '#1976d2' }}>
                            <CloudUpload style={{ color: 'white', width: 20, height: 20 }} />
                        </div>
                        {/* {this.state.newSelection && (
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();  // Klick nicht weiterleiten
                                    this.props.onSelect?.(null);
                                    this.setState({ newSelection: false });
                                }}
                                style={{
                                    position: 'sticky',
                                    top: -8,
                                    right: -8,
                                    background: '#d3302f',
                                    color: '#fff',
                                    borderRadius: '50%',
                                    width: 20,
                                    height: 20,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    fontSize: 12,
                                    lineHeight: '20px',
                                }}
                                title="Auswahl entfernen"
                            >
                                ✕
                            </div>
                        )} */}
                    </div>
                    {this.props.helperText?.length > 0 &&
                        <Typography style={{ color: this.errColor, fontSize: 12, marginLeft: 14 }}>{this.props.helperText}</Typography>
                    }

                </div>

                <MediaManagerDialog
                    open={this.state.mediaDialogOpen}
                    onClose={() => { this.setState({ mediaDialogOpen: false }) }}
                    onSelect={(fileItem) => {
                        console.log("Selected file item: ", fileItem);
                        this.props.onSelect?.(fileItem.path);
                        this.setState({ mediaDialogOpen: false, newSelection: true });
                    }}
                    typePreSelection={this.props.typePreSelection || "products"}
                />
            </>
        )
    }
}

export default CloudImageField